import { SingleActionConfig } from "./SingleActionConfig";

export class AlwaysValidActionConfig extends SingleActionConfig {
  isValid = () => true;
}
